export const data = [
  {
    id: Math.random() * 10,
    name: "Notifications_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "notificationTitle",
        label: "Title",
        type: "Text Box(Multi Line)",
        min: 0,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "notificationBody",
        label: "Description",
        type: "Text Box(Multi Line)",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "profileType",
        label: "Profile Type ",

        dropdowndata: [
          "Transporter_Broker",
          "Company_Logistics",
          "Shipper_Manufacturer_Trader",
          "Logistics_Booking_Business",
          "Transporter_Commission_Agent",
          "Fleet_Owner",
          "Single_Truck_Owner_Driver",
        ],
        type: "Multi-Select",
      },
    ],
  },
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "imageUrl",
        label: "File",
      },
    ],
  },
];

export const DataForSpecificAcccounts = [
  {
    id: Math.random() * 10,
    name: "Notifications_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "notificationTitle",
        label: "Title",
        type: "Text Box(Multi Line)",
        min: 0,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "notificationBody",
        label: "Description",
        type: "Text Box(Multi Line)",
        min: 0,
        max: Infinity,
      },

      {
        id: Math.random() * 10,
        name: "password",
        label: "Password",
        type: "password",
        min: 0,
        max: Infinity,
      },
    ],
  },
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "imageUrl",
        label: "File",
      },
    ],
  },
];
